import React, { Component } from 'react';
import http from '../../modules/api';

class DisplayHomePopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 0, // 1: Category, 2: Goal, 3: Loading/Success
      selectedCategory: '',
      loadingProgress: 0,
      loadingText: 'Analyzing... 0%',
      isSuccess: false,

      categories: [],
      selected_category_code_cd: '',
      methods: [],
    };
  }

  componentDidMount() {
    this.getStoreCategoryList();
  }

  getStoreCategoryList() {
        http.get("/rest/shop/rp/storeCategory/list"
            // + "?start_idx=" + this.state.startIdx
            // + "&row_cnt=" + this.state.rowcnt
        )
        .then(res => {
            if (res.data != null && res.data != '') {
                if (res.data.list && res.data.list.length > 0) {
                    let categories = res.data.list;
                    categories.forEach((item, idx) => {
                        if (item.category_cd === this.state.selected_category_code_cd) {
                            categories[idx]["selected"] = true;
                        }
                    });
                    this.setState({
                        categories: categories,
                        totalCnt: res.data.totalCnt,
                        step: 1,
                    });
                }
            } else {
              this.setState({
                step: 1,
              });
            }
        })
        .catch(error => {
          this.setState({
            step: 1,
          });
        });
    }

    getStoreMethodList() {
      this.setState({methods: []}, () => {
        http.get("/rest/shop/rp/customerMethod/list"
          + "?category_cd=" + this.state.selected_category_code_cd
            // + "&start_idx=" + this.state.startIdx
            // + "&row_cnt=" + this.state.rowcnt
        )
        .then(res => {
            if (res.data != null && res.data != '') {
                if (res.data.list && res.data.list.length > 0) {
                  let methods = res.data.list;
                  methods.forEach((item, idx) => {
                      if (item.method_cd === this.state.selected_method_cd) {
                        methods[idx]["selected"] = true;
                      }
                  });
                  this.setState({
                    methods: res.data.list,
                    totalCnt: res.data.totalCnt,
                    step: 2,
                  });
                }
            } else {
              this.setState({
                step: 2,
              });
            }
        })
        .catch(error => {
          this.setState({
            step: 2,
          });
        });
      });
    }

  // 화면 전환 시 스크롤 상단 이동
  scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  handleCategorySelect = (category) => {
    this.setState({ selectedCategory: category, step: 2 }, () => {
      this.scrollToTop();
    });
  };

  onClickCategoryButton(idx) {
      const categories = [...this.state.categories];
      categories.map((item) => item.selected = false);
      categories[idx]["selected"] = true;
      this.setState({
          categories: categories,
          selected_category_code_cd: categories[idx].category_cd,
      }, () => {
          this.getStoreMethodList(); // 메소드 코트 로딩 후 step 2로 이동
      });
  } 

  onClickMethodButton(idx) {
    const methods = [...this.state.methods];
    methods.map((item) => item.selected = false);
    methods[idx]["selected"] = true;
    this.setState({
      methods: methods,
      selected_method_code_cd: methods[idx].method_cd,
      step: 3,
    }, () => {
      this.startSimulation();
    });
  }

  goToStep1 = () => {
    this.setState({ step: 1 }, () => {
      this.scrollToTop();
    });
  };

  handleGoalSelect = (goalType) => {
    // Start Loading sequence
    this.setState({ step: 3 }, () => {
      this.startSimulation();
    });
  };

  startSimulation = () => {
    // Phase 1: Progress 70%
    setTimeout(() => {
      this.setState({
        loadingProgress: 70,
        loadingText: 'Setting Logic... 70%'
      });
    }, 100);

    // Phase 2: Complete
    setTimeout(() => {
      this.setState({
        loadingProgress: 100,
        loadingText: 'Complete!',
        isSuccess: true
      }, () => {
        setTimeout(() => {
          window.location.href =
            "/shop/rp/ParentAutoRpSetting" +
            "?category_cd=" + this.state.selected_category_code_cd +
            "&method_cd=" + this.state.selected_method_code_cd;
        }, 700);
      });
      console.log("Redirecting to dashboard...");
    }, 1800);
  };

  render() {
    const { step, isSuccess, loadingProgress, loadingText, categories, methods } = this.state;

    return (
      <div id="robo-popup">
        <style>{`
          /* --- CSS Scoping: #robo-popup --- */
          body:has(#robo-popup) {
            overflow: hidden;
          }

          #robo-popup {
            --color-mint: #00e2e6;
            --color-mint-hover: #00bfc2;
            --color-mint-light: rgba(0, 226, 230, 0.05);
            --color-navy: #0A1A2F;
            --color-navy-light: #1f2937;
            --color-gray-bg: #f3f4f6;
            --color-text: #0A1A2F;
            --color-gray-sub: #6b7280;
            --color-border: #f3f4f6;
          }

          #robo-popup .modal-overlay {
            font-family: 'Noto Sans KR', sans-serif;
            /* background-color: rgba(10, 26, 47, 0.6); */
            /* backdrop-filter: blur(4px); */
            min-height: 100vh;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 40px 16px;
            box-sizing: border-box;
          }
          
          #robo-popup * { box-sizing: border-box; margin: 0; padding: 0; }
          #robo-popup button { background: none; border: none; cursor: pointer; font-family: inherit; }

          /* Modal Container */
          #robo-popup .modal-container {
            background-color: #fff;
            width: 100%;
            min-width: 896px;
            max-width: 970px;
            height: auto;
            max-height: 90vh;
            border-radius: 16px;
            box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
            position: relative;
            display: flex;
            flex-direction: column;
            overflow: hidden;
          }

          /* Header */
          #robo-popup .modal-header {
            background-color: var(--color-navy);
            box-shadow: inset 0 0 0 16px var(--color-navy);
            padding: 24px;
            flex-shrink: 0;
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
          }
          #robo-popup .header-badge {
            background-color: rgba(0, 226, 230, 0.2);
            color: var(--color-mint);
            border: 1px solid rgba(0, 226, 230, 0.3);
            padding: 2px 8px;
            border-radius: 4px;
            font-size: 10px;
            font-weight: 700;
          }
          #robo-popup .header-title {
            font-size: 20px; font-weight: 700; color: #fff; letter-spacing: -0.025em; margin-top: 4px;
          }
          #robo-popup .header-desc {
            font-size: 14px; font-weight: 300; color: #d1d5db; margin-top: 4px;
          }
          #robo-popup .btn-close {
            color: #9ca3af; padding: 4px; font-size: 20px; transition: color 0.2s;
          }
          #robo-popup .btn-close:hover { color: #fff; }

          #robo-popup .modal-body { display: flex; padding: 24px 24px 0px 24px; overflow: hidden; justify-content: center; }
          @media (min-width: 768px) { #robo-popup .modal-body { padding: 32px 32px 0px 32px;} }

          /* Progress Dots */
          #robo-popup .progress-wrap { display: flex; justify-content: center; margin-bottom: 24px; gap: 8px; }
          #robo-popup .dot { height: 8px; border-radius: 9999px; transition: all 0.3s; }
          #robo-popup .dot.active { width: 32px; background-color: var(--color-navy); }
          #robo-popup .dot.inactive { width: 8px; background-color: #e5e7eb; }
          #robo-popup .dot.clickable { cursor: pointer; }
          #robo-popup .dot.clickable:hover { background-color: var(--color-mint); }

          /* Typography */
          #robo-popup .section-title {
            font-size: 20px; font-weight: 700; color: var(--color-navy); text-align: center; margin-bottom: 32px;
          }
          #robo-popup .highlight { color: var(--color-mint); border-bottom: 2px solid var(--color-mint); }

          /* Step 1: Grid */
          #robo-popup .category-grid {
            display: grid; grid-template-columns: repeat(2, 1fr); gap: 12px;
            height: 100%;
            padding-bottom: 24px;
            overflow-y: auto;
          }
          @media (min-width: 768px) { #robo-popup .category-grid { grid-template-columns: repeat(3, 1fr); padding-bottom: 32px;} }
          @media (min-width: 1024px) { #robo-popup .category-grid { grid-template-columns: repeat(4, 1fr); } }

          #robo-popup .category-btn {
            padding: 16px;
            border: 2px solid var(--color-border);
            border-radius: 12px;
            display: flex; align-items: center; gap: 12px;
            text-align: left; transition: all 0.2s; background-color: #fff;
          }
          #robo-popup .category-btn:hover {
            border-color: var(--color-mint); background-color: var(--color-mint-light);
          }
          #robo-popup .cat-icon {
            width: 40px; height: 40px; border-radius: 8px; 
            /* background-color: #f9fafb; */
            flex-shrink: 0; display: flex; align-items: center; justify-content: center;
            font-size: 24px; transition: background-color 0.2s;
          }
          #robo-popup .category-btn:hover .cat-icon { /* background-color: #fff; */ }
          #robo-popup .cat-text { font-weight: 700; color: #4b5563; font-size: 16px; }
          #robo-popup .category-btn:hover .cat-text { color: var(--color-navy); }

          /* Step 2: List */
          #robo-popup .goal-list { display: flex; flex-direction: column; gap: 16px; }
          #robo-popup .goal-btn {
            width: 100%; padding: 20px;
            border: 2px solid var(--color-border);
            border-radius: 16px;
            display: flex; align-items: flex-start; gap: 20px;
            text-align: left; transition: all 0.2s; background-color: #fff;
          }
          @media (min-width: 768px) { #robo-popup .goal-btn { align-items: center; } }
          #robo-popup .goal-btn:hover {
            border-color: var(--color-mint); background-color: var(--color-mint-light);
          }
          #robo-popup .goal-icon {
            width: 56px; height: 56px; border-radius: 9999px; background-color: #f3f4f6;
            flex-shrink: 0; display: flex; align-items: center; justify-content: center;
            font-size: 24px; transition: all 0.2s; margin-top: 4px;
          }
          @media (min-width: 768px) { #robo-popup .goal-icon { margin-top: 0; } }
          #robo-popup .goal-btn:hover .goal-icon { background-color: var(--color-mint); color: #fff; }

          #robo-popup .goal-content { flex-grow: 1; }
          #robo-popup .goal-title { font-size: 20px; font-weight: 700; color: var(--color-navy); margin-bottom: 4px; transition: color 0.2s; }
          #robo-popup .goal-btn:hover .goal-title { color: var(--color-mint); }
          #robo-popup .goal-desc { font-size: 16px; color: #6b7280; line-height: 1.5; }
          #robo-popup .goal-highlight { font-weight: 500; color: var(--color-navy); }
          #robo-popup .goal-arrow { font-size: 20px; color: #d1d5db; margin-left: auto; display: none; }
          @media (min-width: 768px) { #robo-popup .goal-arrow { display: block; } }
          #robo-popup .goal-btn:hover .goal-arrow { color: var(--color-mint); }

          #robo-popup .footer-nav { margin-top: 32px; padding-top: 16px; border-top: 1px solid var(--color-border); text-align: center; margin-bottom: 24px; }
          @media (min-width: 768px) { #robo-popup .footer-nav { margin-bottom: 32px; } }
          #robo-popup .btn-back {
            display: inline-flex; align-items: center; justify-content: center; gap: 8px;
            padding: 8px 24px; border-radius: 8px; color: #6b7280; font-weight: 500;
            transition: all 0.2s;
          }
          #robo-popup .btn-back:hover { background-color: #f3f4f6; color: var(--color-navy); }

          /* Loading Screen */
          #robo-popup .loading-wrap {
            display: flex; flex-direction: column; align-items: center; justify-content: center;
            text-align: center; padding: 48px 0;
            animation: fadeIn 0.5s ease-in-out;
          }
          #robo-popup .spinner-container { position: relative; width: 112px; height: 112px; margin-bottom: 32px; transition: all 0.5s; }
          #robo-popup .spinner-bg { position: absolute; inset: 0; border: 4px solid #f3f4f6; border-radius: 50%; }
          #robo-popup .spinner-active {
            position: absolute; inset: 0; border: 4px solid var(--color-mint);
            border-top-color: transparent; border-radius: 50%;
            animation: spin 1s linear infinite;
          }
          #robo-popup .spinner-emoji { position: absolute; inset: 0; display: flex; align-items: center; justify-content: center; font-size: 36px; }

          @keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
          @keyframes pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.5; } }
          @keyframes bounce { 0%, 100% { transform: translateY(0); animation-timing-function: cubic-bezier(0.8,0,1,1); } 50% { transform: translateY(-25%); animation-timing-function: cubic-bezier(0,0,0.2,1); } }
          @keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }

          #robo-popup .status-title { font-size: 30px; font-weight: 700; color: var(--color-navy); margin-bottom: 16px; }
          #robo-popup .status-title.pulsing { animation: pulse 2s infinite; }
          #robo-popup .status-desc { font-size: 18px; color: #6b7280; margin-bottom: 40px; height: 64px; line-height: 1.6; }

          #robo-popup .progress-track { width: 100%; max-width: 384px; background-color: #f3f4f6; height: 12px; border-radius: 9999px; overflow: hidden; margin: 0 auto; }
          #robo-popup .progress-fill { height: 100%; background-color: var(--color-mint); width: 0%; border-radius: 9999px; transition: width 2000ms ease-out; }
          #robo-popup .progress-text { font-size: 14px; color: #9ca3af; font-family: monospace; margin-top: 12px; }

          #robo-popup .success-msg { margin-top: 32px; animation: fadeIn 0.5s forwards; }
          #robo-popup .success-title { color: var(--color-mint); font-weight: 700; font-size: 20px; margin-bottom: 8px; display: flex; align-items: center; justify-content: center; gap: 8px; }
          
          #robo-popup .success-icon-wrap {
            width: 112px; height: 112px; border-radius: 50%; background-color: var(--color-mint);
            display: flex; align-items: center; justify-content: center; color: white; font-size: 48px;
            box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
            animation: bounce 1s infinite;
          }

          /* Utilities */
          #robo-popup .fade-in-view { display: flex; flex-direction: column; animation: fadeIn 0.4s ease-out forwards; flex: 1; }
          #robo-popup .br-mobile { display: block; }
          @media (min-width: 768px) { #robo-popup .br-mobile { display: none; } }
        `}</style>

        {
          step != 0
          &&
            <div className="modal-overlay">
              <div className="modal-container">
                
                <div className="modal-header">
                  <div>
                    <div style={{display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px'}}>
                      <span className="header-badge">ROBO MD AI</span>
                      <h3 className="header-title">맞춤 진열 설정 마법사</h3>
                    </div>
                    <p className="header-desc">쇼핑몰 상황에 맞는 알고리즘을 세팅합니다.</p>
                  </div>
                  <button className="btn-close" onClick={() => { this.props.onClose && this.props.onClose(); }}>
                    <i className="fas fa-times"></i>
                  </button>
                </div>

                <div className="modal-body">

                  {/* Step 1: Category Selection */}
                  {step === 1 && (
                    <div className="fade-in-view">
                      <div className="progress-wrap">
                        <div className="dot active"></div>
                        <div className="dot inactive"></div>
                        <div className="dot inactive"></div>
                      </div>

                      <h4 className="section-title">
                        Q1. 운영 중인 쇼핑몰의 <span className="highlight">업종</span>을 선택해주세요.
                      </h4>
                      
                      <div className="category-grid">
                        {
                        // [
                        //   { id: '여성의류', icon: '👗', text: '여성의류' },
                        //   { id: '남성의류', icon: '👕', text: '남성의류' },
                        //   { id: '아동의류', icon: '🧸', text: '아동의류/용품' },
                        //   { id: '쥬얼리', icon: '💍', text: '쥬얼리/잡화' },
                        //   { id: '식품', icon: '🍎', text: '식품/농수산' },
                        //   { id: '공구', icon: '🔧', text: '공구/기계' },
                        //   { id: '유니폼', icon: '🥼', text: '유니폼/병원' },
                        //   { id: '생활', icon: '🛋️', text: '생활/인테리어' },
                        //   { id: '스포츠', icon: '🎽', text: '취미/스포츠' },
                        //   { id: '중국상품', icon: '🚢', text: '중국상품판매' },
                        //   { id: '플랫폼', icon: '🏢', text: '플랫폼' },
                        //   { id: '도매', icon: '🏘️', text: '도매/회원몰' },
                        //   { id: '사무용품', icon: '📋', text: '사무용품' },
                        // ].map(cat => (
                        //   <button key={cat.id} onClick={() => this.handleCategorySelect(cat.id)} className="category-btn">
                        //     <div className="cat-icon">{cat.icon}</div>
                        //     <span className="cat-text">{cat.text}</span>
                        //   </button>
                        // ))
                        categories.map((cat, idx) => (
                          <button key={cat.category_cd} onClick={() => this.onClickCategoryButton(idx)} className="category-btn">
                            <div className="cat-icon">{cat.emoji}</div>
                            <span className="cat-text">{cat.category_name}</span>
                          </button>
                        ))
                        }
                      </div>
                    </div>
                  )}

                  {/* Step 2: Goal Selection */}
                  {step === 2 && (
                    <div className="fade-in-view">
                      <div className="progress-wrap">
                        <div className="dot inactive clickable" onClick={this.goToStep1}></div>
                        <div className="dot active"></div>
                        <div className="dot inactive"></div>
                      </div>

                      <h4 className="section-title">
                        Q2. 현재 쇼핑몰의 <span className="highlight">운영 목표</span>는 무엇인가요?
                      </h4>

                      <div className="goal-list">
                      {
                        methods.map((method, idx) => (
                          <button onClick={() => this.onClickMethodButton(idx)} className="goal-btn">
                            <div className="goal-icon">{method.emoji}</div>
                            <div className="goal-content">
                              <p className="goal-title" dangerouslySetInnerHTML={{__html: method.val1}}></p>
                              <p className="goal-desc" dangerouslySetInnerHTML={{__html: method.val2}}></p>
                            </div>
                            <div className="goal-arrow"><i className="fas fa-chevron-right"></i></div>
                          </button>
                        ))
                      }

                      {/* 
                        <button onClick={() => this.handleGoalSelect('starter')} className="goal-btn">
                          <div className="goal-icon">🌱</div>
                          <div className="goal-content">
                            <p className="goal-title">이제 막 시작했어요</p>
                            <p className="goal-desc">
                              판매 데이터가 부족해도 괜찮아요.<br className="br-mobile" />
                              <span className="goal-highlight">조회수·장바구니</span> 데이터를 섞어 상품을 다양하게 회전시킵니다.
                            </p>
                          </div>
                          <div className="goal-arrow"><i className="fas fa-chevron-right"></i></div>
                        </button>

                        <button onClick={() => this.handleGoalSelect('growth')} className="goal-btn">
                          <div className="goal-icon">🚀</div>
                          <div className="goal-content">
                            <p className="goal-title">광고를 하며 성장 중이에요</p>
                            <p className="goal-desc">
                              광고 클릭이 구매로 이어지도록,<br className="br-mobile" />
                              <span className="goal-highlight">실제 판매와 조회수가 높은 상품</span>을 우선 진열합니다.
                            </p>
                          </div>
                          <div className="goal-arrow"><i className="fas fa-chevron-right"></i></div>
                        </button>

                        <button onClick={() => this.handleGoalSelect('trend')} className="goal-btn">
                          <div className="goal-icon">⚡</div>
                          <div className="goal-content">
                            <p className="goal-title">상품 변화가 빠르고 트렌드에 민감해요</p>
                            <p className="goal-desc">
                              고객 반응을 즉각 반영하고 싶으신가요?<br className="br-mobile" />
                              <span className="goal-highlight">최신(1일) 데이터</span>를 집중 분석해 급상승 상품을 바로 노출합니다.
                            </p>
                          </div>
                          <div className="goal-arrow"><i className="fas fa-chevron-right"></i></div>
                        </button> */}
                      </div>
                      
                      <div className="footer-nav">
                        <button onClick={this.goToStep1} className="btn-back">
                          <i className="fas fa-arrow-left" style={{fontSize: '14px'}}></i> 이전 단계로
                        </button>
                      </div>
                    </div>
                  )}

                  {/* Step 3: Loading & Success */}
                  {step === 3 && (
                    <div className="loading-wrap">
                      
                      {/* Icon Switcher */}
                      <div className="spinner-container">
                        {isSuccess ? (
                          <div className="success-icon-wrap">
                            <i className="fas fa-check"></i>
                          </div>
                        ) : (
                          <>
                            <div className="spinner-bg"></div>
                            <div className="spinner-active"></div>
                            <div className="spinner-emoji">🤖</div>
                          </>
                        )}
                      </div>
                      
                      {/* Title & Description */}
                      {isSuccess ? (
                        <>
                          <h4 className="status-title">최적화 완료!</h4>
                          <div className="status-desc">
                            사장님 쇼핑몰을 위한<br />맞춤형 자동 진열 설정이 끝났습니다.
                          </div>
                          <div className="success-msg">
                            <p className="success-title"><i className="fas fa-check-circle"></i>설정 완료!</p>
                            <p style={{color: '#6b7280'}}>운영 현황 대시보드로 이동합니다.</p>
                          </div>
                        </>
                      ) : (
                        <>
                          <h4 className="status-title pulsing">알고리즘 최적화 중...</h4>
                          <p className="status-desc">
                            선택하신 업종과 운영 방식에 맞춰<br />
                            <span style={{fontWeight: 700, color: 'var(--color-navy)'}}>최적의 진열 로직</span>을 생성하고 있습니다.
                          </p>
                          <div className="progress-track">
                            <div className="progress-fill" style={{width: `${loadingProgress}%`}}></div>
                          </div>
                          <p className="progress-text">{loadingText}</p>
                        </>
                      )}

                    </div>
                  )}

                </div>
              </div>
            </div>
        }
        </div>

    );
  }
}

export default DisplayHomePopup;